import { render } from "./px-navbar-wizard.vue?vue&type=template&id=18bbaab8&scoped=true&ts=true"
import script from "./px-navbar-wizard.vue?vue&type=script&lang=ts"
export * from "./px-navbar-wizard.vue?vue&type=script&lang=ts"

import "./px-navbar-wizard.vue?vue&type=style&index=0&id=18bbaab8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bbaab8"]])

export default __exports__